/**
 * @license
 * Copyright (C) 2022 Anna Plodari
 * Software proprietario - Tutti i diritti riservati.
 * Registrato SIAE - Sezione OLAF.
 *
 * È vietato qualsiasi utilizzo non autorizzato, copia, modifica, estrazione,
 * riuso, rielaborazione, distribuzione, reverse engineering o decompilazione
 * del software, delle API, delle logiche applicative e dei dati del database.
 *
 * L'accesso al codice non costituisce concessione di licenza.
 */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

interface Props {
  current: number;
  onChangeTab: Function;
}

const UpgradeTab: React.FC<Props> = function UpgradeTab({ current, onChangeTab }) {

  return (
    <div>
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        <select
          id="tabs"
          name="tabs"
          className="block w-full rounded-md bg-lightgrey p-4 border-r-[16px] border-r-lightgrey"
          defaultValue="">
          <option key="Card">CARD</option>
          <option key="Alert DataBase">Alert Database</option>
          <option key="Alert NewProfile">Alert NewProfile</option>
          <option key="Promuovi ricerca">Promuovi ricerca</option>
          <option key="Promuovi brand">Promuovi brand</option>
          {/* <option key="Apl">Apl</option> */}
        </select>
      </div>
      <div className="hidden sm:block">
        <nav className="flex space-x-4 bg-lightgrey py-2 px-4 rounded-md justify-center w-fit" aria-label="Tabs">
        
         {current !== 5 && <>
            <span
              key="Card"
              role="button"
              className={`px-3 py-2 rounded-md ${current === 0 ? 'bg-white text-black' : 'text-textgrey hover:text-black'
                }`}
              onClick={() => onChangeTab(0)}>
              CARD
            </span>
            <span
              key="Alert DataBase"
              role="button"
              className={`px-3 py-2 rounded-md ${current === 1 ? 'bg-white text-black' : 'text-textgrey hover:text-black'
                }`}
              onClick={() => onChangeTab(1)}>
              Alert Database
            </span>
            <span
              key="Alert NewProfile"
              role="button"
              className={`px-3 py-2 rounded-md ${current === 2 ? 'bg-white text-black' : 'text-textgrey hover:text-black'
                }`}
              onClick={() => onChangeTab(2)}>
              Alert NewProfile
            </span>
            <span
              key="Promuovi ricerca"
              role="button"
              className={`px-3 py-2 rounded-md ${current === 3 ? 'bg-white text-black' : 'text-textgrey hover:text-black'
                }`}
              onClick={() => onChangeTab(3)}>
                Promuovi ricerca
            </span>
             <span
              key="Promuovi brand"
              role="button"
              className={`px-3 py-2 rounded-md ${current === 4 ? 'bg-white text-black' : 'text-textgrey hover:text-black'
                }`}
              onClick={() => onChangeTab(4)}>
                Promuovi brand
            </span>
           </>}
          {current === 5 && <span
            key="Apl"
            role="button"
            className={`px-3 py-2 rounded-md ${current === 5 ? 'bg-white text-black' : 'text-textgrey hover:text-black'
              }`}
            onClick={() => onChangeTab(5)}>
            Card
          </span>}
        </nav>
      </div>
    </div>
  );
};

export default UpgradeTab;